import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getVersion } from '@/lib/version';
import ChangelogModal from '@/components/changelog/ChangelogModal';

export default function Footer() {
  const [version, setVersion] = useState<string>('');
  const [changelogOpen, setChangelogOpen] = useState(false);

  useEffect(() => {
    getVersion().then((versionInfo) => {
      setVersion(versionInfo.version);
    });
  }, []);

  return (
    <footer className="border-t bg-muted/50 mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <h3 className="mb-4 font-semibold text-navy">Dining Steward</h3>
            <p className="text-sm text-muted-foreground">
              From labour to refreshment, with precision and elegance.
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-semibold">Product</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-foreground">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/" className="text-muted-foreground hover:text-foreground">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/" className="text-muted-foreground hover:text-foreground">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-semibold">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-foreground">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/" className="text-muted-foreground hover:text-foreground">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-semibold">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Dining Steward. All rights reserved.</p>
          {version && (
            <p className="mt-2 text-xs opacity-75">
              <button
                type="button"
                onClick={() => setChangelogOpen(true)}
                className="hover:text-foreground underline transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy rounded"
              >
                Version {version}
              </button>
              {' • '}
              <button
                type="button"
                onClick={() => setChangelogOpen(true)}
                className="hover:text-foreground underline transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy rounded"
              >
                Changelog
              </button>
            </p>
          )}
        </div>
      </div>
      <ChangelogModal open={changelogOpen} onOpenChange={setChangelogOpen} />
    </footer>
  );
}

